import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Laptop.svg",
  "use": "Laptop.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Laptop.svg\"><path d=\"M57.01,51.0208h-50a3,3,0,0,1-3-3,1,1,0,0,1,1-1h5v-29a5,5,0,0,1,5-5h34a5,5,0,0,1,5,5v29h5a1,1,0,0,1,1,1A3,3,0,0,1,57.01,51.0208Zm-7-33a1,1,0,0,0-1-1h-34a1,1,0,0,0-1,1v25a1,1,0,0,0,1,1h34a1,1,0,0,0,1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol